export var HTTPMethod;

(function (HTTPMethod) {
  HTTPMethod["Post"] = "post";
  HTTPMethod["Get"] = "get";
  HTTPMethod["Put"] = "put";
  HTTPMethod["Patch"] = "patch";
  HTTPMethod["Delete"] = "delete";
  HTTPMethod["Head"] = "head";
  HTTPMethod["Options"] = "options";
})(HTTPMethod || (HTTPMethod = {}));